module.exports = __webpack_public_path__ + "img/bt-more.578aef4e.png";